/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "DigitalWalletSendSuccessfulProvisionEmailRequest": {
                "fields": {
                  "notificationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailRequest.Platform",
                    "id": 4,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "panLastFour": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Platform": {
                    "values": {
                      "DO_NOT_USE_UNKNOWN": 0,
                      "APPLE_WALLET": 1,
                      "GOOGLE_WALLET": 2
                    }
                  }
                }
              },
              "DigitalWalletSendSuccessfulProvisionEmailResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailResponse.Success",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendSuccessfulProvisionEmailRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendSuccessfulProvisionEmailRequest?.nested?.Platform && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendSuccessfulProvisionEmailResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendSuccessfulProvisionEmailResponse?.nested?.Success) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DigitalWalletSendSuccessfulProvisionEmailRequest @ squareup/corporate_card/service/digital_wallet_status_emails.proto at 10:1
 */
export const DigitalWalletSendSuccessfulProvisionEmailRequest = $root.lookupType('squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailRequest');
fixType(DigitalWalletSendSuccessfulProvisionEmailRequest, {
  notificationId: {
    notEmpty: true
  },
  cardToken: {
    required: true
  },
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletSendSuccessfulProvisionEmailRequest);
/**
 * SOURCE Platform @ squareup/corporate_card/service/digital_wallet_status_emails.proto at 25:3
 */
DigitalWalletSendSuccessfulProvisionEmailRequest.Platform = $root.lookupEnum('squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailRequest.Platform').values;
/**
 * SOURCE DigitalWalletSendSuccessfulProvisionEmailResponse @ squareup/corporate_card/service/digital_wallet_status_emails.proto at 32:1
 */
export const DigitalWalletSendSuccessfulProvisionEmailResponse = $root.lookupType('squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailResponse');
fixType(DigitalWalletSendSuccessfulProvisionEmailResponse);
Builder.createAndAttachToType(DigitalWalletSendSuccessfulProvisionEmailResponse);
/**
 * SOURCE Success @ squareup/corporate_card/service/digital_wallet_status_emails.proto at 33:3
 */
DigitalWalletSendSuccessfulProvisionEmailResponse.Success = $root.lookupType('squareup.corporate_card.service.DigitalWalletSendSuccessfulProvisionEmailResponse.Success');
fixType(DigitalWalletSendSuccessfulProvisionEmailResponse.Success);
Builder.createAndAttachToType(DigitalWalletSendSuccessfulProvisionEmailResponse.Success);